import { routes } from '@/constants/Constants';

import { ApplicationTabId } from '@/modules/application-tracker/api';
import {
  SEARCH_TEXT_QUERY_PARAM,
  TAB_QUERY_PARAM,
} from '@/modules/application-tracker/screens/applications-table/constants';

/**
 * App Tracker → All applications, searched by applicant email.
 * One email can match several records, so this opens search — not a single deal.
 */
export const buildInviteEligibilitySearchPath = (email: string): string => {
  const params = new URLSearchParams({
    [TAB_QUERY_PARAM]: ApplicationTabId.AllApplications,
    [SEARCH_TEXT_QUERY_PARAM]: email.trim().toLowerCase(),
  });
  return `${routes.dealsDashboard}?${params.toString()}`;
};
